import { ReactNode } from 'react'
import { styled } from '@mui/material'
import { DialogContent } from '@carto/meridian-ds/components'

const Content = styled(DialogContent, {
  shouldForwardProp: (prop: string) => !['error', 'withBorder'].includes(prop)
})<{ error?: boolean; withBorder?: boolean }>(({ error, withBorder, theme }) => ({
  gap: 0,
  border: withBorder ? `1px solid ${theme.palette.divider} !important` : undefined,
  borderBottom: error ? 'none !important' : undefined,

  '.react-codemirror2': {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%'
  },
  '.CodeMirror-wrap': {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  '& + .MuiDivider-root': {
    display: 'none'
  }
}))

interface CodeAreaDialogContentProps {
  children: string | ReactNode
  error?: boolean
  withBorder?: boolean
  withGutter?: boolean
}

export default function CodeAreaDialogContent({
  children,
  error,
  withBorder = true,
  withGutter = false
}: CodeAreaDialogContentProps) {
  if (!children) return null

  return (
    <Content withGutter={withGutter} error={error} withBorder={withBorder}>
      {children}
    </Content>
  )
}
